import React from 'react';
import ArticlesRulesTable from '../components/ArticlesRulesTable';

const ReguliArticole = () => {   
  return (
    <>
      <ArticlesRulesTable />
    </>
  );
};

export default ReguliArticole;
